import { FC } from "react";

interface DataSourceViewProps {
  dataSourceTitle: string;
}

export const DataSourceView: FC<DataSourceViewProps> = ({ dataSourceTitle }) => {
  return (
    <div className="flex w-full items-center gap-2">
      <div className="min-w-0 flex-1 break-words">{dataSourceTitle}</div>
    </div>
  );
};

export default DataSourceView;
